(function () {

  // ─── Config ───────────────────────────────────────────────────────────────
  // Each of Form A and Form B is independently configurable:
  //
  //   enabled: true/false — master switch for this form's script-side
  //                          handling (teaser display + entry/exit
  //                          triggers). Unpublishing a form in Klaviyo only
  //                          stops openForm() from rendering anything — it
  //                          has no effect on our own teaser, since that's
  //                          entirely client-side. Set this to false
  //                          alongside unpublishing to also stop the
  //                          teaser/triggers from running for that form.
  //                          Existing cookies (teaser/engaged/shown/
  //                          submitted) are left untouched while disabled,
  //                          so re-enabling later resumes from wherever
  //                          state was left off — nothing is cleared.
  //   formIds: [...]       — array of Klaviyo form IDs, plural. Normally
  //                          just one. During a scheduled promo cutover
  //                          (old form unpublished, new form published at
  //                          a set time), list both IDs here — openForm()
  //                          fires for all of them on every trigger, and
  //                          since an unpublished form's openForm() call is
  //                          a confirmed silent no-op, whichever one is
  //                          actually live is the one that renders. No
  //                          manual script edit needed at cutover time;
  //                          just remove the retired ID afterward for
  //                          cleanliness. The event listener also matches
  //                          against every ID in this list, so submit/close
  //                          events from either form are handled correctly
  //                          during the overlap window.
  //   enabled: true/false — master switch for this form's script-side
  //                          handling (teaser display + entry/exit
  //                          triggers). Unpublishing a form in Klaviyo only
  //                          stops openForm() from rendering anything — it
  //                          has no effect on our own teaser, since that's
  //                          entirely client-side. Set this to false
  //                          alongside unpublishing to also stop the
  //                          teaser/triggers from running for that form.
  //                          Existing cookies (teaser/engaged/shown/
  //                          submitted) are left untouched while disabled,
  //                          so re-enabling later resumes from wherever
  //                          state was left off — nothing is cleared.
  //   triggerMode: 'entry' — auto-opens the full modal on load (after
  //                          entryDelayMs or entryScrollPercent, whichever
  //                          comes first). If teaserEnabled, closing it
  //                          without submitting steps down to the teaser.
  //                'exit'  — no auto-popup on load. If teaserEnabled, shows
  //                          the teaser immediately instead; if not, shows
  //                          nothing until the exit-intent/idle fallback
  //                          fires.
  //   teaserEnabled: true  — a persistent teaser tab is used as described
  //                          above, and closing the teaser (not the modal)
  //                          is what triggers the 7-day shown suppression.
  //                 false — no teaser at all. Closing the modal directly
  //                          triggers the 7-day shown suppression, same as
  //                          the very first version of this script.
  //
  // In both modes, exit-intent/idle/mobile-visibility acts as a fallback —
  // either the sole trigger (exit mode) or a rescue for visitors who never
  // engage with the teaser at all — and is skipped once that form's
  // engaged cookie is set for the session.
  var FORM_A_CONFIG = {
    enabled:            false,
    formIds:            ['RgDbwm'],
    teaserCookie:       'klv_form_a_teaser',
    engagedCookie:      'klv_form_a_engaged',
    triggerMode:        'entry',   // 'entry' | 'exit'
    teaserEnabled:      false,
    teaserLabel:        "Save 10% on today's order!", // only used when teaserEnabled is true
    entryDelayMs:       3000,     // only used when triggerMode === 'entry'
    entryScrollPercent: 25        // only used when triggerMode === 'entry'
  };

  var FORM_B_CONFIG = {
    enabled:            false,
    formIds:            ['UufEPR'],
    teaserCookie:       'klv_form_b_teaser',
    engagedCookie:      'klv_form_b_engaged',
    triggerMode:        'entry',   // 'entry' | 'exit'
    teaserEnabled:      false,
    teaserLabel:        "Save 10% on today's order!", // only used when teaserEnabled is true
    entryDelayMs:       3000,     // only used when triggerMode === 'entry'
    entryScrollPercent: 25        // only used when triggerMode === 'entry'
  };

  var FORM_ID_C            = 'SWy4rm'; // manual "#email-signup" trigger
  var MANUAL_TRIGGER_HASH  = '#email-signup';

  var DISCOUNT_SUBMITTED_COOKIE  = 'klv_discount_submitted'; // shared: A + B
  var DISCOUNT_SHOWN_COOKIE      = 'klv_discount_shown';     // shared: A + B
  var SESSION_COOKIE             = 'klv_session_traffic';
  var EMAIL_SOURCE_COOKIE        = 'klv_email_source';       // session-scoped; excludes A + B entirely

  var SUBMITTED_SUPPRESSION_DAYS = 90;
  var SHOWN_SUPPRESSION_DAYS     = 7;
  var TEASER_MAX_AGE_DAYS        = 30; // safety net if a teaser is never explicitly closed
  var IDLE_MS                    = 10000;


  // ─── Cookie Utilities ─────────────────────────────────────────────────────
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  function checkDateCookie(cookieName, days) {
    var value = getCookie(cookieName);
    if (!value) return 'absent';
    var date = new Date(value);
    var daysSince = (Date.now() - date.getTime()) / (1000 * 60 * 60 * 24);
    return daysSince < days ? 'valid' : 'stale';
  }

  function nowISO() {
    return new Date().toISOString();
  }

  // Render/measure DOM only once document.body exists.
  function ensureBodyReady(fn) {
    if (document.body) fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }


  // ─── Shared: open a Klaviyo form by ID ─────────────────────────────────────
  // anyModalOpen tracks whether ANY of the three forms is currently open —
  // set the moment one is opened (regardless of which), cleared on any
  // 'close' event. A/B's auto-triggers (entry/exit-intent) check this
  // before firing so they never pop over top of an already-open modal,
  // most importantly Form C, which a visitor opened intentionally.
  var anyModalOpen = false;

  function openForm(formId) {
    anyModalOpen = true;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  // Opens the form described by cfg. Arms that form's teaser cookie (only
  // if teaserEnabled) and marks the session "engaged" — both happen the
  // moment it opens, not just on close. This closes a race window: without
  // it, a second tab loading before the first tab's modal is dismissed sees
  // a "clean slate" and independently triggers its own popup/fallback.
  // Marking "engaged" here covers every way the modal can open (teaser
  // click, entry trigger, or exit-intent fallback), since they all call
  // this same function.
  function openFormFor(cfg) {
    if (cfg.teaserEnabled) {
      setCookie(cfg.teaserCookie, nowISO(), TEASER_MAX_AGE_DAYS);
    }
    setCookie(cfg.engagedCookie, 'true', null);
    for (var i = 0; i < cfg.formIds.length; i++) {
      openForm(cfg.formIds[i]);
    }
  }

  // Handles a Klaviyo submit/close event for a given form's config.
  function handleFormEvent(cfg, teaserObj, type) {
    if (!cfg.enabled) return; // defensive — shouldn't normally fire while disabled

    if (type === 'submit') {
      setCookie(DISCOUNT_SUBMITTED_COOKIE, nowISO(), SUBMITTED_SUPPRESSION_DAYS);
      // Submitting does NOT clear an active teaser — the code may still be
      // worth referencing later.
    } else if (type === 'close') {
      if (cfg.teaserEnabled) {
        setCookie(cfg.teaserCookie, nowISO(), TEASER_MAX_AGE_DAYS);
        ensureBodyReady(teaserObj.show);
      } else {
        // No teaser to step down to — closing is a full dismissal.
        setCookie(DISCOUNT_SHOWN_COOKIE, nowISO(), SHOWN_SUPPRESSION_DAYS);
      }
    }
  }


  // ─── Trigger mechanics ──────────────────────────────────────────────────────
  // Entry trigger: fires on whichever comes first — a fallback timer, or
  // the visitor scrolling past entryScrollPercent of the page. Only used
  // when triggerMode === 'entry'.
  function setupEntryTrigger(cfg, openFn) {
    var fired = false;

    function fire() {
      if (fired) return;

      if (anyModalOpen) {
        // Another modal (most likely Form C, opened intentionally by the
        // visitor) is currently up — don't interrupt it. Retry after the
        // same delay rather than firing over top of it.
        clearTimeout(timer);
        timer = setTimeout(fire, cfg.entryDelayMs);
        return;
      }

      fired = true;
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      openFn();
    }

    var timer = setTimeout(fire, cfg.entryDelayMs);

    function onScroll() {
      var scrollTop = window.scrollY || window.pageYOffset;
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return; // page shorter than viewport — timer will handle it
      var percentScrolled = (scrollTop / scrollable) * 100;
      if (percentScrolled >= cfg.entryScrollPercent) fire();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Exit-intent / idle / mobile fallback — used either as the sole trigger
  // (exit mode) or as a rescue for visitors who never engage with a teaser.
  function setupExitIntentTrigger(openFn) {
    var fired = false;

    function fire() {
      if (fired) return;

      if (anyModalOpen) {
        // Another modal (most likely Form C) is currently up — don't
        // interrupt it. The idle path retries after another IDLE_MS;
        // mousemove/visibility paths just ignore this event and wait for
        // the next qualifying one, since their listeners stay attached.
        clearTimeout(idleTimer);
        idleTimer = setTimeout(fire, IDLE_MS);
        return;
      }

      fired = true;

      clearTimeout(idleTimer);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mousemove', resetIdleTimer);
      document.removeEventListener('keypress', resetIdleTimer);
      document.removeEventListener('scroll', resetIdleTimer);
      document.removeEventListener('visibilitychange', onVisibilityChange);

      openFn();
    }

    var idleTimer;
    function resetIdleTimer() {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(fire, IDLE_MS);
    }

    document.addEventListener('keypress', resetIdleTimer, { passive: true });
    document.addEventListener('mousemove', resetIdleTimer, { passive: true });
    document.addEventListener('scroll', resetIdleTimer, { passive: true });
    resetIdleTimer();

    var isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    function onMouseMove(e) {
      if (e.clientY < 20) fire();
    }
    if (!isMobile) {
      document.addEventListener('mousemove', onMouseMove, { passive: true });
    }

    function onVisibilityChange() {
      if (document.visibilityState === 'hidden') fire();
    }
    if (isMobile) {
      document.addEventListener('visibilitychange', onVisibilityChange);
    }
  }


  // ─── Custom teaser factory (used by both Form A and Form B) ───────────────
  // Klaviyo's native teaser doesn't persist across page loads, so we build
  // our own. Structure: an un-rotated wrapper holds position:fixed (the
  // only element that does, so scrollbar/viewport shifts move everything as
  // one unit); the pill inside is rotated for vertical text; the close
  // badge sits at the wrapper's own un-rotated top-left corner, which —
  // because rotating the pill doesn't change the wrapper's box — always
  // lands visually on the pill's physical corner.
  function makeTeaser(openFn, teaserCookieName, labelText) {
    var wrapEl = null;
    var closeBtn = null;

    function build() {
      if (wrapEl) return;

      wrapEl = document.createElement('div');
      wrapEl.style.cssText = [
        'position:fixed', 'top:50%', 'right:0',
        'transform:translateY(-50%)',
        'z-index:9999'
      ].join(';');

      var pillEl = document.createElement('div');
      pillEl.setAttribute('role', 'button');
      pillEl.setAttribute('aria-label', 'Reopen discount offer');
      pillEl.style.cssText = [
        'transform:rotate(180deg)',
        'writing-mode:vertical-rl', 'text-orientation:mixed',
        'background:#334FB4', 'color:#FFFFFF',
        'font-family:"Plus Jakarta Sans",sans-serif', 'font-size:14px', 'font-weight:600',
        'letter-spacing:.02em', 'line-height:1.3',
        'padding:18px 10px', 'border-radius:0 8px 8px 0',
        'cursor:pointer',
        'display:flex', 'align-items:center', 'justify-content:center',
        'box-shadow:0 2px 8px rgba(0,0,0,.2)'
      ].join(';');

      var label = document.createElement('span');
      label.textContent = labelText;
      pillEl.appendChild(label);

      pillEl.addEventListener('click', function () {
        openFn();
      });

      closeBtn = document.createElement('div');
      closeBtn.setAttribute('role', 'button');
      closeBtn.setAttribute('aria-label', 'Dismiss offer');
      closeBtn.textContent = '✕';
      closeBtn.style.cssText = [
        'position:absolute', 'top:-8px', 'left:-8px',
        'width:22px', 'height:22px', 'border-radius:50%',
        'background:#FFFFFF', 'color:#334FB4',
        'display:flex', 'align-items:center', 'justify-content:center',
        'font-family:"Plus Jakarta Sans",sans-serif', 'font-size:14px', 'font-weight:700', 'line-height:1',
        'cursor:pointer',
        'box-shadow:0 1px 4px rgba(0,0,0,.25)'
      ].join(';');
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        // Closing either teaser fully suppresses BOTH forms for the shown
        // suppression window — shared cookie.
        setCookie(DISCOUNT_SHOWN_COOKIE, nowISO(), SHOWN_SUPPRESSION_DAYS);
        deleteCookie(teaserCookieName);
        hide();
      });

      wrapEl.appendChild(pillEl);
      wrapEl.appendChild(closeBtn);
      document.body.appendChild(wrapEl);
    }

    function show() {
      build();
      wrapEl.style.display = 'block';
    }

    function hide() {
      if (wrapEl) wrapEl.style.display = 'none';
    }

    return { show: show, hide: hide };
  }

  var teaserA = makeTeaser(function () { openFormFor(FORM_A_CONFIG); }, FORM_A_CONFIG.teaserCookie, FORM_A_CONFIG.teaserLabel);
  var teaserB = makeTeaser(function () { openFormFor(FORM_B_CONFIG); }, FORM_B_CONFIG.teaserCookie, FORM_B_CONFIG.teaserLabel);


  // ─── Klaviyo event listener — routes by form ID ────────────────────────────
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail) return;
    var id = e.detail.formId;
    var type = e.detail.type;

    if (type === 'close') {
      anyModalOpen = false;
    }

    if (FORM_A_CONFIG.formIds.indexOf(id) !== -1) {
      handleFormEvent(FORM_A_CONFIG, teaserA, type);
    } else if (FORM_B_CONFIG.formIds.indexOf(id) !== -1) {
      handleFormEvent(FORM_B_CONFIG, teaserB, type);
    }
    // Form C: no cookie bookkeeping beyond the anyModalOpen tracking above —
    // still always independently triggerable.
  });


  // ─── Form C: manual "#email-signup" trigger (always active) ───────────────
  function manualTriggerC() {
    openForm(FORM_ID_C);
  }

  function handleHash() {
    if (window.location.hash === MANUAL_TRIGGER_HASH) manualTriggerC();
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest ? e.target.closest('a[href$="' + MANUAL_TRIGGER_HASH + '"]') : null;
    if (!target) return;
    e.preventDefault();
    manualTriggerC();
  });

  window.addEventListener('hashchange', handleHash);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    handleHash();
  } else {
    document.addEventListener('DOMContentLoaded', handleHash);
  }


  // ─── Forms A / B: gated by shared suppression state ────────────────────────
  // Traffic-source detection happens first and unconditionally, since the
  // email exclusion below needs to override even an already-armed teaser
  // from a prior visit.
  if (!getCookie(SESSION_COOKIE)) {
    var params = new URLSearchParams(window.location.search);
    var campaign = params.get('utm_campaign') || 'organic';
    setCookie(SESSION_COOKIE, campaign, null);

    var source = (params.get('utm_source') || '').toLowerCase();
    if (source === 'email') {
      setCookie(EMAIL_SOURCE_COOKIE, 'true', null);
    }
  }

  if (getCookie(EMAIL_SOURCE_COOKIE)) {
    // Visitor arrived via an email campaign link — excluded from both
    // Form A and Form B for the rest of this browser session. Form C
    // (manual #email-signup trigger) is untouched by this and stays active.
    return;
  }

  // Segment resolved once, up front — A and B now follow identical logic
  // below, just parameterized by each form's config object.
  var isOrganic = getCookie(SESSION_COOKIE) === 'organic';
  var cfg        = isOrganic ? FORM_A_CONFIG : FORM_B_CONFIG;
  var teaserObj  = isOrganic ? teaserA : teaserB;

  if (!cfg.enabled) {
    // This form's handling is fully switched off — no teaser, no
    // entry/exit triggers. Cookies are left as-is; this only stops new
    // activity for the current page load.
    return;
  }

  function openThisForm() {
    openFormFor(cfg);
  }

  // An explicit teaser-close (or a direct modal-close when no teaser is
  // enabled) is the only thing that fully retires this form for the window.
  var shownStatus = checkDateCookie(DISCOUNT_SHOWN_COOKIE, SHOWN_SUPPRESSION_DAYS);
  if (shownStatus === 'stale') deleteCookie(DISCOUNT_SHOWN_COOKIE);

  if (shownStatus === 'valid') {
    return;
  }

  if (cfg.teaserEnabled) {
    var teaserStatus = checkDateCookie(cfg.teaserCookie, TEASER_MAX_AGE_DAYS);
    if (teaserStatus === 'stale') deleteCookie(cfg.teaserCookie);

    if (teaserStatus === 'valid') {
      // Teaser is active — persists regardless of submitted status. Restore
      // it, and re-arm the exit-intent fallback if not yet engaged.
      ensureBodyReady(teaserObj.show);
      if (!getCookie(cfg.engagedCookie)) setupExitIntentTrigger(openThisForm);
      return;
    }
  }

  var submittedStatus = checkDateCookie(DISCOUNT_SUBMITTED_COOKIE, SUBMITTED_SUPPRESSION_DAYS);
  if (submittedStatus === 'stale') deleteCookie(DISCOUNT_SUBMITTED_COOKIE);

  if (submittedStatus === 'valid') {
    // Submitted, and no teaser to restore — nothing more to show.
    return;
  }

  // Clean slate.
  if (!getCookie(cfg.engagedCookie)) {
    if (cfg.triggerMode === 'entry') {
      setupEntryTrigger(cfg, openThisForm);
    } else {
      if (cfg.teaserEnabled) {
        setCookie(cfg.teaserCookie, nowISO(), TEASER_MAX_AGE_DAYS);
        ensureBodyReady(teaserObj.show);
      }
      setupExitIntentTrigger(openThisForm);
    }
  }

})();